import * as React from 'react';
import './App.css';

interface EmojiType {
  emoji: string;
  name: string;
}

const food: EmojiType[] = [
  { emoji: '🍇', name: 'Grapes' },
  { emoji: '🍈', name: 'Melon' },
  { emoji: '🍉', name: 'Watermelon' },
  { emoji: '🍊', name: 'Tangerine' },
  { emoji: '🍋', name: 'Lemon' },
  { emoji: '🍌', name: 'Banana' },
  { emoji: '🍍', name: 'Pineapple' },
  { emoji: '🍎', name: 'Red Apple' },
  { emoji: '🍏', name: 'Green Apple' },
  { emoji: '🍐', name: 'Pear' },
  { emoji: '🍑', name: 'Peach' },
  { emoji: '🍒', name: 'Cherries' },
  { emoji: '🍓', name: 'Strawberry' },
  { emoji: '🥝', name: 'Kiwi Fruit' },
  { emoji: '🍅', name: 'Tomato' },
  { emoji: '🥥', name: 'Coconut' },
  { emoji: '🥑', name: 'Avocado' },
  { emoji: '🍆', name: 'Eggplant' },
  { emoji: '🥔', name: 'Potato' },
  { emoji: '🥕', name: 'Carrot' },
  { emoji: '🌽', name: 'Ear of Corn' },
  { emoji: '🌶', name: 'Hot Pepper' },
  { emoji: '🥒', name: 'Cucumber' },
  { emoji: '🥦', name: 'Broccoli' },
  { emoji: '🍄', name: 'Mushroom' },
  { emoji: '🥜', name: 'Peanuts' },
  { emoji: '🌰', name: 'Chestnut' },
  { emoji: '🍞', name: 'Bread' },
  { emoji: '🥐', name: 'Croissant' },
  { emoji: '🥖', name: 'Baguette Bread' },
  { emoji: '🥨', name: 'Pretzel' },
  { emoji: '🥞', name: 'Pancakes' },
  { emoji: '🧀', name: 'Cheese Wedge' },
  { emoji: '🍖', name: 'Meat on Bone' },
  { emoji: '🍗', name: 'Poultry Leg' },
  { emoji: '🥩', name: 'Cut of Meat' },
  { emoji: '🥓', name: 'Bacon' },
  { emoji: '🍔', name: 'Hamburger' },
  { emoji: '🍟', name: 'French Fries' },
  { emoji: '🍕', name: 'Pizza' },
  { emoji: '🌭', name: 'Hot Dog' },
  { emoji: '🥪', name: 'Sandwich' },
  { emoji: '🌮', name: 'Taco' },
  { emoji: '🌯', name: 'Burrito' },
  { emoji: '🍳', name: 'Cooking' },
  { emoji: '🍲', name: 'Pot of Food' },
  { emoji: '🥣', name: 'Bowl With Spoon' },
  { emoji: '🥗', name: 'Green Salad' },
  { emoji: '🍿', name: 'Popcorn' },
  { emoji: '🥫', name: 'Canned Food' },
  { emoji: '🍱', name: 'Bento Box' },
  { emoji: '🍘', name: 'Rice Cracker' },
  { emoji: '🍙', name: 'Rice Ball' },
  { emoji: '🍚', name: 'Cooked Rice' },
  { emoji: '🍛', name: 'Curry Rice' },
  { emoji: '🍜', name: 'Steaming Bowl' },
  { emoji: '🍝', name: 'Spaghetti' },
  { emoji: '🍠', name: 'Roasted Sweet Potato' },
  { emoji: '🍢', name: 'Oden' },
  { emoji: '🍣', name: 'Sushi' },
  { emoji: '🍤', name: 'Fried Shrimp' },
  { emoji: '🍥', name: 'Fish Cake With Swirl' },
  { emoji: '🍡', name: 'Dango' },
  { emoji: '🥟', name: 'Dumpling' },
  { emoji: '🥠', name: 'Fortune Cookie' },
  { emoji: '🥡', name: 'Takeout Box' },
  { emoji: '🍦', name: 'Soft Ice Cream' },
  { emoji: '🍧', name: 'Shaved Ice' },
  { emoji: '🍨', name: 'Ice Cream' },
  { emoji: '🍩', name: 'Doughnut' },
  { emoji: '🍪', name: 'Cookie' },
  { emoji: '🎂', name: 'Birthday Cake' },
  { emoji: '🍰', name: 'Shortcake' },
  { emoji: '🥧', name: 'Pie' },
  { emoji: '🍫', name: 'Chocolate Bar' },
  { emoji: '🍬', name: 'Candy' },
  { emoji: '🍭', name: 'Lollipop' },
  { emoji: '🍮', name: 'Custard' },
  { emoji: '🍯', name: 'Honey Pot' },
];

const drinks: EmojiType[] = [
  { emoji: '🍼', name: 'Baby Bottle' },
  { emoji: '🥛', name: 'Glass of Milk' },
  { emoji: '☕', name: 'Hot Beverage' },
  { emoji: '🍵', name: 'Teacup Without Handle' },
  { emoji: '🍶', name: 'Sake' },
  { emoji: '🍾', name: 'Bottle With Popping Cork' },
  { emoji: '🍷', name: 'Wine Glass' },
  { emoji: '🍸', name: 'Cocktail Glass' },
  { emoji: '🍹', name: 'Tropical Drink' },
  { emoji: '🍺', name: 'Beer Mug' },
];

interface Props {
  emojis: EmojiType[];
}

const Emoji = ({ emojis }: Props) => (
  <span className="Emoji">
    {emojis[Math.floor(Math.random() * Date.now()) % emojis.length].emoji}
  </span>
);

const Fika = () => (
  <div className="Fika">
    <Emoji emojis={food} /><span>+</span><Emoji emojis={drinks} />
  </div>
);

class App extends React.Component {

  private onClick = () => {
    this.forceUpdate();
  }

  render() {
    return (
      <div className="App" onClick={this.onClick}>
        <Fika />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx